<template>

  <div class="container_top">
    <div v-for="(item, index) in soundList" style="background-color: white">
      <div class="item-layout">
        <!-- 左边的布局 -->
        <div class="left-layout">
          <img class="item-icon-view" :src="item.icon"/>
          <div class="item-title-view">{{ item.name }}</div>
          <img
            class="item-play-view"
            :src="item.isPlaying ? '@/../static/voice_stop_icon.png' : '@/../static/voice_play_icon.png'"
            @click="onPlayOrStop(index)"/>
        </div>

        <!-- 右边的布局 -->
        <div class="right-layout" @click="onChecked(index)">
          <div>
            <RadioView :checked="item.isChecked"/>
          </div>
        </div>
      </div>
      <div class="divider">
      </div>
    </div>

    <audio id="musicMp3" controls="" style="display: none"></audio>

  </div>

</template>

<script>

import TitleBarStore from '@/components/widgets/TitleBarStore'
import RadioView from '@/components/widgets/RadioView'
import Vue from 'vue'
import app from '@/AppData'
import Constants from '@/components/setting/Constants'
import jsbridge from '@/jsbridge'
import lubanapi from '@/lubanapi'

export default {

  name: 'AISoundPage',

  components: {
    RadioView
  },

  created () {
    let that = this
    console.log('created')
    document.addEventListener('visibilitychange', function () {
      console.log(document.visibilityState)
      // 不管怎样，都停止播放
      that.resetMp3()
    })
  },

  data () {

    let defaultChecked = false
    let businessChecked = false
    let hpNvChecked = false
    if (!app.isVip()) {
      // 非会员
      defaultChecked = true
    } else {
      // 会员
      let roleId = Constants.DEFAULT_ROLE_ID
      roleId = app.getData().userSetting.voiceRole || 0
      if (roleId == Constants.BUSINESS_ROLE_ID) {
        businessChecked = true
      } else if (roleId == Constants.LIVE_ROLE_ID) {
        hpNvChecked = true
      }
      if (!businessChecked && !hpNvChecked) {
        defaultChecked = true
      }
    }

    return {

      soundList: [
        {
          icon: '@/../static/ren_wenrou.png',
          name: Constants.getVoiceRoleName(Constants.DEFAULT_ROLE_ID),
          url: 'https://yycdn-75403.gzc.vod.tencent-cloud.com/Gentle_Female_Voice_id4.wav',
          isPlaying: false,
          isChecked: defaultChecked,
          id: Constants.DEFAULT_ROLE_ID
        },
        {
          icon: '@/../static/ren_nan.png',
          name: Constants.getVoiceRoleName(Constants.BUSINESS_ROLE_ID),
          url: 'https://yycdn-75403.gzc.vod.tencent-cloud.com/Business_Man_Voive_id1.wav',
          isPlaying: false,
          isChecked: businessChecked,
          id: Constants.BUSINESS_ROLE_ID
        },
        {
          icon: '@/../static/ren_huopo.png',
          name: Constants.getVoiceRoleName(Constants.LIVE_ROLE_ID),
          url: 'https://yycdn-75403.gzc.vod.tencent-cloud.com/Lively_Female_Voice_id1003.wav',
          isPlaying: false,
          isChecked: hpNvChecked,
          id: Constants.LIVE_ROLE_ID
        },
      ],

      audioUrl: ''
    }
  },

  methods: {

    onPlayOrStop (index) {
      console.log(index)
      let isPlaying = this.soundList[index].isPlaying
      this.resetMp3()
      if (!isPlaying) {
        this.audioUrl = this.soundList[index].url
        this.playMp3(this.audioUrl, index)
      }
    },

    resetMp3 () {
      console.log('resetMp3')
      this.soundList.forEach(item => {
        item.isPlaying = false
      })
      const musicMp3 = document.getElementById('musicMp3')
      musicMp3.pause()
      musicMp3.currentTime = 0
    },

    playMp3 (url, index) {
      console.log('playMp3')
      lubanapi.reportseer('AICall_Character_Select_Page_Audition_Button_Click')
      this.soundList[index].isPlaying = true
      Vue.set(this.soundList, index, this.soundList[index])

      const musicMp3 = document.getElementById('musicMp3')
      musicMp3.setAttribute('src', url)
      console.log(musicMp3)
      let that = this
      musicMp3.addEventListener('ended', function () {
        that.resetMp3()
      })
      musicMp3.addEventListener('error', function () {
        that.resetMp3()
      })
      musicMp3.play()
    },

    onChecked (index) {
      lubanapi.reportseer('AICall_Character_Select_Page_Switch_Operating')
      console.log('onChecked, index:' + index)
      let item = this.soundList[index]
      if (item.isChecked) {
        return
      }
      if (!app.isVip()) {
        jsbridge.showVipGuideDialog(this)
        return
      }
      app.getData().userSetting.voiceRole = item.id
      // 先刷新UI
      this.soundList.forEach(it => {
        if (it.id == item.id) {
          it.isChecked = true
        } else {
          it.isChecked = false
        }
      })
      app.reportProfile().then(value => {
        console.log('success')
      }, reason => {
        console.log('fail, reason:' + JSON.stringify(reason))
      })
    }

  },

  mounted () {
    TitleBarStore.store.showvipicon()
    lubanapi.reportseer('AICall_Character_Select_Page_Shown')
  }

}

</script>

<style scoped>

.container_top {
  width: 100%;
  height: 100%;
  background-color: #FAFAFA;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: 1rem;
}

.item-layout {
  width: 100%;
  height: 5.63rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  /*margin-left: 1.00rem;*/
  /*margin-right: 1.00rem;*/
}

.left-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 1rem;
}

.item-icon-view {
  width: 3.44rem;
  height: 3.44rem;
}

.item-title-view {
  font-size: 1.00rem;
  /*color: #000000;*/
  margin-left: 0.5rem;
}

.item-play-view {
  width: 1.50rem;
  height: 1.50rem;
  margin-left: 0.5rem;
}

.right-layout {
  flex: 1;
  margin-right: 1rem;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  background: white;
}


.divider {
  margin-left: 20%;
  width: 80%;
  height: 1px;
  background-color: #FAFAFA;
  /*background: red;*/
}
</style>



// WEBPACK FOOTER //
// src/components/setting/AISoundPage.vue